import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { User } from '@recruitee/account-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class UserHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(): Observable<User[]> {
    return this.httpApi.get('/admins').pipe(map(response => response.admins));
  }
}
